// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__yF9DN","subheading":"Privacy_subheading__c4mpI","indent":"Privacy_indent__+bOcq"};